// @ts-nocheck
import * as React from "react";

const HeartPlus: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10.667 19.333 9.554 18.33a128.054 128.054 0 0 1-3.659-3.46c-.974-.966-1.749-1.826-2.324-2.58-.574-.752-.98-1.441-1.216-2.066A5.32 5.32 0 0 1 2 8.328c0-1.225.416-2.252 1.248-3.083C4.08 4.415 5.108 4 6.333 4c.847 0 1.642.217 2.384.65.742.433 1.392 1.064 1.95 1.89.558-.826 1.208-1.457 1.95-1.89A4.648 4.648 0 0 1 15 4c1.115 0 2.061.347 2.839 1.04a4.329 4.329 0 0 1 1.426 2.59h-.99a3.174 3.174 0 0 0-1.147-1.926A3.286 3.286 0 0 0 15 4.963c-.781 0-1.49.22-2.128.662-.637.441-1.243 1.11-1.818 2.005h-.774c-.584-.908-1.196-1.579-1.837-2.014a3.673 3.673 0 0 0-2.11-.653c-.94 0-1.736.32-2.39.96-.653.64-.98 1.442-.98 2.405 0 .542.112 1.092.337 1.65.225.558.626 1.2 1.204 1.927.577.726 1.364 1.58 2.359 2.559.995.98 2.263 2.168 3.804 3.566l1.45-1.313c.475-.432.9-.827 1.274-1.185l.105.105.238.238.238.238.106.106c-.378.358-.8.746-1.265 1.164-.466.417-.938.848-1.417 1.291l-.73.66Zm6.481-3.037v-2.889H14.26v-.963h2.89V9.556h.962v2.889H21v.962h-2.889v2.89h-.963Z"
            />
        </svg>
    );
};

export default React.memo(HeartPlus);
